/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";

import { AuthRoute, IAuthRoute } from "@src/components/AuthRoute";
import { PageNotFound } from "@src/components/PageNotFound";
import { routeLoader } from "@advapacs/common";
const UserListContainer = React.lazy(() =>
  routeLoader(() => import("./UserListContainer"))
);
const UserDetail = React.lazy(() => routeLoader(() => import("./UserDetail")));
const UserCreate = React.lazy(() => routeLoader(() => import("./UserCreate")));
const UserUpdate = React.lazy(() => routeLoader(() => import("./UserUpdate")));

const routes: Array<IAuthRoute> = [
  {
    path: "/",
    element: <UserListContainer />,
    can: [],
    index: true,
  },
  {
    path: "/:id",
    element: <UserDetail />,
    can: [],
    index: true,
  },
  {
    path: "/Create",
    element: <UserCreate />,
    can: [],
    index: true,
  },
  {
    path: "/:id/Edit",
    element: <UserUpdate />,
    can: [],
    index: true,
  },
];

const UserRoute: FC = () => {
  return (
    <>
      <Routes>
        {routes.map((route) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              index={route.index}
              element={<AuthRoute can={route.can} element={route.element} />}
            />
          );
        })}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
};

export const UserRouter = {
  element: <UserRoute />,
  path: "/Users/*",
};
